module.exports = __webpack_public_path__ + "static/media/chat-bubble-dark.937652be.svg";